var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "app min-h-screen",
    class: {
      'native-app': _vm.$device.isNative
    }
  }, [_vm._t("default"), _vm._v(" "), _c('PortalTarget', {
    attrs: {
      "name": "popup",
      "multiple": ""
    }
  }), _vm._v(" "), _c('PortalTarget', {
    attrs: {
      "name": "overlay",
      "multiple": ""
    }
  }), _vm._v(" "), _c('PortalTarget', {
    attrs: {
      "name": "dropdown",
      "multiple": ""
    }
  }), _vm._v(" "), _c('PortalTarget', {
    attrs: {
      "name": "highest",
      "multiple": ""
    }
  }), _vm._v(" "), _c('global-snackbar'), _vm._v(" "), _c('global-popup-alert'), _vm._v(" "), _c('PortalTarget', {
    attrs: {
      "name": "tooltip",
      "multiple": ""
    }
  })], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }